var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.91 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.15,10.23c-.14,0-.26,.11-.28,.25-.6,4.39-4.36,7.77-8.91,7.77-2.61,0-4.95-1.12-6.6-2.89-.1-.1-.1-.27-.02-.38l.88-1.15c.11-.15,.32-.15,.44,0,1.28,1.49,3.18,2.43,5.29,2.43,3.41,0,6.25-2.45,6.87-5.68,.03-.18-.11-.34-.29-.34h-2c-.24,0-.37-.27-.23-.46l3.42-4.49c.12-.15,.34-.15,.46,0l3.42,4.49c.14,.19,0,.46-.23,.46h-2.23Zm-15.76-1.98c-.18,0-.32-.17-.29-.34,.63-3.22,3.46-5.66,6.86-5.66,2.11,0,4,.94,5.28,2.42,.12,.14,.33,.14,.44,0l.88-1.15c.09-.11,.08-.27-.02-.38-1.64-1.77-3.98-2.88-6.59-2.88C7.41,.25,3.65,3.62,3.05,8c-.02,.14-.14,.25-.28,.25H.54c-.24,0-.37,.27-.23,.46l3.42,4.49c.12,.15,.34,.15,.46,0l3.42-4.49c.14-.19,0-.46-.23-.46h-1.99Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorder);
export default __webpack_public_path__ + "static/media/reorder.b69d8307d5dc8a7ebcec9d24d745ee54.svg";
export { ForwardRef as ReactComponent };